module.exports = __webpack_public_path__ + "img/9788931011272.f29c53b8.jpg";